import { render, staticRenderFns } from "./SortGroupModal.vue?vue&type=template&id=f0cabe7c&scoped=true&"
import script from "./SortGroupModal.vue?vue&type=script&lang=js&"
export * from "./SortGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./SortGroupModal.vue?vue&type=style&index=0&id=f0cabe7c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cabe7c",
  null
  
)

export default component.exports